import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-dropdown-select';
import services from '../../services';
import './User.css';
import { MultiSelect } from 'react-multi-select-component';
import { toast } from 'react-toastify';
import DeletePopup from '../DeletePopup';
import { FormControlLabel, Switch } from '@mui/material';

const UserAssignBoard = () => {
    const { state } = useLocation();
    const [allPermission, setAllPermission] = useState([]);
    const [boardColumn, setBoardColumn] = useState([]);
    const [selectedPerIds, setSelectedPerIds] = useState([]);
    const [selectedColumnIds, setSelectedColumnIds] = useState([]);
    const [selectedBoards, setSelectedBoards] = useState([]);
    const [boardName, setBoardName] = useState([]);
    const navigate = useNavigate();
    const [allASSIGNMENT, setAllASSIGNMENT] = useState([]);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [columnError, setColumnError] = useState(false);
    const [isManager, setIsManager] = useState(false);

    const handleToggle = (event) => {
        setIsManager(event.target.checked);
    };

    const handleManagerToggle = (index, checked) => {
        const updatedAssignments = [...allASSIGNMENT];
        updatedAssignments[index] = {
            ...updatedAssignments[index],
            isManager: checked,
        };
        setAllASSIGNMENT(updatedAssignments);
    };

    const handleSelect = (selected) => {
        setSelectedBoards(selected);
        if (selected && selected.length > 0) {
            getBoardColumn(selected[0].value);
        } else {
            setBoardColumn([]);
        }
    };

    const assignedBoardIds = allASSIGNMENT?.map((a) => a.Board?.value);
    const availableBoards = boardName.filter((b) => !assignedBoardIds.includes(b.value));

    const handleEditBoard = async (id, item) => {
        const data = {
            boardId: item.Board?.value,
            userId: state.id,
            boardListId: item.boardListId?.map((col) => col),
            permissions: item.permissions?.map((per) => per),
            isManager:item?.isManager
        };
        try {
            const response = await services.userassignboard.UPDATE_UserAssignBoard(id, data);
            if (response.status === 200) {
                toast.success('Assignment updated successfully');
                GET_ALL_ASSIGNMENT();
            }
        } catch (e) {
            console.error(e);
            toast.error('Failed to update assignment');
        }
    };

    const getAllBoard = async () => {
        try {
            const { data } = await services.board.GETALLBOARD();
            const filterData =
                (data && data.length > 0 && data.map(({ boardName, id }) => ({ label: boardName, value: id }))) || [];

            setBoardName(filterData);
            GET_ALL_ASSIGNMENT(filterData);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getAllBoard();
        GET_ALL_PERMISSION();
    }, []);

    const GET_ALL_PERMISSION = async () => {
        try {
            const response = await services.permission.GET_ALL_PERMISSION();
            const data =
                (response &&
                    response.length > 0 &&
                    response.map((item) => ({
                        ...item,
                        label: item.name,
                        permission_details: item.details,
                        value: item.id,
                    }))) ||
                [];
            setAllPermission(data);
        } catch (e) {
            console.error(e);
        }
    };

    const getBoardColumn = async (id) => {
        try {
            const response = await services.board.SELECTED_BOARD(id);
            const data = response?.data?.map((item) => ({
                value: item?.id,
                label: item?.coloum,
            }));
            setBoardColumn(data);
        } catch (e) {
            console.error(e);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!selectedColumnIds || selectedColumnIds?.length === 0) {
            setColumnError(true);
            return;
        }
        const data = {
            boardId: selectedBoards[0]?.value,
            userId: state.id,
            boardListId: selectedColumnIds.map((item) => item),
            permissions: selectedPerIds.map((item) => item),
            isManager:isManager
        };
        try {
            const response = await services.userassignboard.CREATE_UserAssignBoard(data);
            if (response.status === 201) {
                toast.success('Board assigned successfully');
                setSelectedBoards([]);
                setSelectedColumnIds([]);
                setSelectedPerIds([]);
                GET_ALL_ASSIGNMENT();
            }
        } catch (e) {
            console.error(e);
        }
    };

    const GET_ALL_ASSIGNMENT = async (filterData) => {
        try {
            const response = await services.userassignboard.GET_UserAssignBoard_ID(state.id);

            const dataMap = response?.data?.data?.map((item, index) => ({
                ...item,
                boardListId: typeof item?.boardListId === 'string' ? JSON.parse(item?.boardListId) : item?.boardListId,
                permissions: typeof item?.permissions === 'string' ? JSON.parse(item?.permissions) : item?.permissions,
                BoardLists: Array.isArray(item?.Board?.BoardLists)
                    ? item.Board.BoardLists.map((listItem) => ({
                        label: listItem?.coloum,
                        value: listItem?.id,
                    }))
                    : [],
                Board: item?.Board
                    ? {
                        label: item.Board.boardName,
                        value: item.Board.id,
                    }
                    : { label: '', value: '' },
            }));
            setAllASSIGNMENT(dataMap || []);
        } catch (e) {
            console.error(e);
        }
    };

    const handleEditCol = (index, selectedOptions) => {
        const allOptions = allASSIGNMENT[index]?.BoardLists || [];
        let updatedSelectedOptions = selectedOptions;

        if (selectedOptions.length === allOptions.length) {
            if (!selectedOptions.some(opt => opt.value === "*")) {
                updatedSelectedOptions = [...selectedOptions, { label: "*", value: "*" }];
            }
        } else {
            updatedSelectedOptions = selectedOptions.filter(opt => opt.value !== "*");
        }
        const updatedAssignments = [...allASSIGNMENT];
        updatedAssignments[index] = {
            ...updatedAssignments[index],
            boardListId: updatedSelectedOptions,
        };
        setAllASSIGNMENT(updatedAssignments);
    };

    const handleDelete = async (id) => {
        setDeleteId(id);
        setShowDeletePopup(true);
    };

    const confirmDelete = async () => {
        try {
            const response = await services.userassignboard.DELETE_UserAssignBoard(deleteId);
            if (response.status === 200) {
                toast.success('Assignment deleted successfully');
                getAllBoard();
            }
        } catch (e) {
            toast.error('Failed to delete assignment');
            console.error(e);
        } finally {
            setShowDeletePopup(false);
            setDeleteId(null);
        }
    };

    const cancelDelete = () => {
        setShowDeletePopup(false);
        setDeleteId(null);
    };

    const handleEditSelect = async (selected, index) => {
        if (!selected || selected.length === 0) return;
        const selectedBoard = selected[0];
        try {
            const response = await services.board.SELECTED_BOARD(selectedBoard.value);
            const columns = response?.data?.map((item) => ({
                value: item?.id,
                label: item?.coloum,
            }));

            const updatedAssignments = [...allASSIGNMENT];
            updatedAssignments[index] = {
                ...updatedAssignments[index],
                Board: selectedBoard,
                BoardLists: columns,
                boardListId: [],
            };
            setAllASSIGNMENT(updatedAssignments);
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <div className="relative user-assign-board-container">
            <div
                className="absolute left-[2vw] right-0  flex items-center"
                style={{ gap: '1rem' }}
            >
                <button
                    className="btn btn-outline-primary ml-5"
                    onClick={() => navigate(-1)}
                    style={{ flexShrink: 0 }}
                >
                    Back
                </button>

                <h1
                    className="header flex-grow text-center text-2xl"
                    style={{ margin: '0 auto' }}
                >
                    Assign Boards and Columns
                </h1>
            </div>


            <div style={{ marginTop: '4vw' }}>
                <div
                    className="label p-2 ml-[2vw]"
                    style={{ display: 'flex', justifyContent: 'start', alignItems: 'start' }}
                >
                    New Assignment
                </div>

                <div>
                    <div className="board-container">
                        <div className="form-row">
                            <div className="form-item">
                                <div className="label">Board</div>
                                <div style={{ width: '65%' }}>
                                    <Select
                                        options={availableBoards}
                                        onChange={handleSelect}
                                        values={selectedBoards}
                                        contentRenderer={({ props, state }) => {
                                            return (
                                                <div
                                                    className='assign-board'
                                                    title={state.values.map((val) => val.label).join(", ")}
                                                >
                                                    {state.values.map((val) => val.label).join(", ")}
                                                </div>
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="form-item">
                                <div className="label">Column</div>
                                <div className="drop-header">
                                    <MultiSelect
                                        options={boardColumn}
                                        value={selectedColumnIds}
                                        onChange={(selectedOptions) => {
                                            setSelectedColumnIds(selectedOptions);
                                            if (selectedOptions.length > 0) setColumnError(false);
                                        }}
                                        labelledBy="Select Column"
                                    />
                                </div>
                                {columnError && (
                                    <div className='column-validation'>
                                        Please select at least one column.
                                    </div>
                                )}
                            </div>
                            <div>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={isManager}
                                            onChange={handleToggle}
                                            name="managerSwitch"
                                            color="primary"
                                        />
                                    }
                                    label="Manager"
                                />
                            </div>

                            <div className="save-item">
                                <button className="btn btn-primary" onClick={handleSubmit}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {allASSIGNMENT?.map((item, index) => {
                const selectedOptions = item?.boardListId || [];
                const allOptions = item?.BoardLists || [];

                const valueToPass = selectedOptions.some(opt => opt.value === "*")
                    ? [...allOptions]
                    : selectedOptions;
                return (
                    <div key={index}>
                        <div className="board-container">
                            <div className="form-row">
                                <div className="form-item">
                                    <div className="label">Board</div>
                                    <div style={{ width: '65%' }}>
                                        <Select
                                            options={boardName}
                                            onChange={(selected) => handleEditSelect(selected, index)}
                                            values={[item?.Board]}
                                            contentRenderer={({ props, state }) => {
                                                return (
                                                    <div
                                                        className='assign-board'
                                                        title={state.values.map((val) => val.label).join(", ")}
                                                    >
                                                        {state.values.map((val) => val.label).join(", ")}
                                                    </div>
                                                );
                                            }}
                                        />

                                    </div>
                                </div>
                                <div className="form-item">
                                    <div className="label">Column</div>
                                    <div className="drop-header">
                                        <MultiSelect
                                            options={item?.BoardLists}
                                            value={valueToPass}
                                            onChange={(selectedOptions) => handleEditCol(index, selectedOptions)}
                                            labelledBy="Select Column"
                                        />
                                    </div>
                                </div>
                                <div>
                                      <FormControlLabel
                                    control={
                                    <Switch
                                        checked={Boolean(item?.isManager)}
                                        name="managerSwitch"
                                        color="primary"
                                        onChange={(e) => handleManagerToggle(index, e.target.checked)}
                                    />
                                       }
                                    label="Manager"
                                />
                                </div>
                                <div className="save-item gap-2">
                                    <button className="btn btn-primary" onClick={() => handleEditBoard(item.id, item)}>
                                        Update
                                    </button>
                                    <button className="btn btn-outline-primary" onClick={() => handleDelete(item.id)}>
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
            {showDeletePopup && (
                <DeletePopup
                    open={showDeletePopup}
                    title="Are you sure you want to delete this assignment?"

                    onConfirm={confirmDelete}
                    onCancel={cancelDelete}
                    confirmLabel="YES, I'M SURE"
                    cancelLabel="NO"
                />
            )}
        </div>
    );
};

export default UserAssignBoard;
